import { Decimal } from 'decimal.js';
import * as inherits from 'yup/lib/util/inherits';
import * as MixedSchema from 'yup/lib/mixed';
import * as isAbsent from 'yup/lib/util/isAbsent';


const parseDecimal = (value) => {
  try {
    return new Decimal(value);
  } catch (e) {
    return new Decimal(NaN);
  }
}


export default function DecimalSchema() {
  if (!(this instanceof DecimalSchema))
    return new DecimalSchema();

  MixedSchema.call(this, { type: 'decimal' });

  this.withMutation(() => {
    this.transform(function(value: any) {
      let parsed = value;

      if (typeof parsed === 'string') {
        parsed = parsed.replace(/\s/g, '');
        if (parsed === '')
          return new Decimal(NaN);

        parsed = parseDecimal(parsed);
       }

      if (this.isType(parsed))
        return parsed;

      return parseDecimal(parsed);
    });
  });
}

// TODO: min, max, etc methods
inherits(DecimalSchema, MixedSchema, {
  _typeCheck(value) {
    return value instanceof Decimal && !value.isNaN();
  },
  min(min, message)  {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: { min },
      test(value: any) {
        return value instanceof Decimal && !value.isNaN() && value.greaterThan(min);
      }
    })
  },
  max(max, message)  {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: { max },
      test(value: any) {
        return value instanceof Decimal && !value.isNaN() && value.lessThan(max);
      }
    })
  }
});

